module.exports = __webpack_public_path__ + "img/buddy_antenna-05.ee5623d3.svg";